import Immutable from 'seamless-immutable';
import { ADD_MESSAGE, RESET_AI_STATE, SET_MESSAGE_STATUS, APPEND_TO_MESSAGE } from '../actions/actionTypes/ai';

const initialState = Immutable({
  messages: []
});

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_MESSAGE:
      return state.setIn(['messages'], [...state.messages, action.message]);
    case SET_MESSAGE_STATUS:
      const messages = state.messages.map((m) => (m.id === action.data.id ? { ...m, status: action.data.status } : m));
      return state.set('messages', messages);
    case APPEND_TO_MESSAGE:
      return state.set(
        'messages',
        state.messages.map((m) => (m.id === action.data.id ? { ...m, content: m.content + action.data.chunk } : m))
      );
    case RESET_AI_STATE:
      return initialState;
    default:
      return state;
  }
}
